import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

export default function AccBank({ accDetails }) {
    return (
        <div>
            <h2 className='orgAccountH2'>Bank Details</h2>
            <div className='orgAccountSecDiv'>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Bank Name'
                        answer={accDetails.bank?.bankName}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Account Holder Name'
                        answer={accDetails.bank?.accName}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Branch Name'
                        answer={accDetails.bank?.branchName}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Account Number'
                        answer={accDetails.bank?.accNum}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='IFSC'
                        answer={accDetails.bank?.ifsc}
                        className='borderNone width50'
                    />
                </div>
            </div>
        </div>
    );
}
